/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mock_Memory_Source2Inputs */

const en_mk_mock_memory_source2 = /** @type {(inputs: Mk_Mock_Memory_Source2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`from Bu Rina's correction`)
};

const id_mk_mock_memory_source2 = /** @type {(inputs: Mk_Mock_Memory_Source2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dari koreksi Bu Rina`)
};

/**
* | output |
* | --- |
* | "from Bu Rina's correction" |
*
* @param {Mk_Mock_Memory_Source2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mock_memory_source2 = /** @type {((inputs?: Mk_Mock_Memory_Source2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mock_Memory_Source2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mock_memory_source2(inputs)
	return en_mk_mock_memory_source2(inputs)
});